import React from "react";
import HeaderContainer from "../Header/HeaderContainer";

import { Affix, Col, Grid, Layout, Row, Space, Typography } from "antd";
import BackBtn from "components/reusables/BackBtn/BackBtnComponent";
import NextStepBtnComponent from "components/reusables/NextStepBtn/NextStepBtnComponent";
import StepFlowComponent from "components/reusables/StepFlow/StepFlowComponent";
import MinimalFooterComponent from "components/reusables/MinimalFooter/MinimalFooterComponent";
import NextBackBtnComponent from "components/reusables/NextBackBtn/NextBackBtnComponent";
const { Title } = Typography;
const { useBreakpoint } = Grid;

/* content images */
import tag from "../../../assets/namespace/img/8_tag.png";
import tagLg from "../../../assets/namespace/img/8_tag_lg.png";
import segMb from "../../../assets/namespace/img/8_seguro.png";
import TextHeaderComponent from "components/reusables/TexlHeader/TextHeaderComponent";
/* end content images */


function ContractTAGServiceContainer() {
  const screens = useBreakpoint();
  return (
    <div id="container">
      <Layout id="body">
        <Space direction="vertical" size={35}>
          <HeaderContainer />
          <Layout
            style={{
              padding: "1rem",
              alignItems: "center",
              maxWidth: "1140px",
              margin: "auto",
            }}
          >
            <TextHeaderComponent />
            <StepFlowComponent current={1} className={""}></StepFlowComponent>
            <Row style={{ justifyContent: "center" }}>
              <Col xs={24} md={20} style={{ maxWidth: "1024px" }}>
                <Space size={24} direction="vertical">
                  <div>
                    {/* TODO: move to component */}
                    <Row style={{ paddingTop: `${!screens["lg"] ? '5px' : '20px'}`, margin: 'auto', maxWidth: '850px', justifyContent: "center" }}>
                      <Col style={{ maxWidth: '630px' }}>
                        <Space size={16} direction="vertical">
                          <Col span={24}>
                            <Title
                              className={"body-text-header"}
                              style={{ textAlign: "center" }}
                            >
                              Contratación de Servicios
                            </Title>
                          </Col>
                          <Row>
                            <div>
                              <Title
                                className={"vehicle-buy-text-description"}
                                level={4}
                              >

                                <span style={{ fontWeight: "700" }}>
                                  ¿Quieres ahorrar tiempo y filas?
                                </span>
                                <br />
                                <span style={{ fontWeight: "400" }}>
                                  En esta etapa de la transferencia se puede elegir si el comprador quiere
                                  recibir el dispositivo Tag cómodamente en su casa y/o contratar un seguro
                                  automotriz.
                                </span>
                                <br />
                                <br />
                                <span style={{ fontWeight: "700", display: screens.md ? 'inline-block' : 'none' }} >
                                  {" "}
                                  Recuerda, aquí exponemos el proceso de
                                  Transferencia a modo de ejemplo.
                                </span>
                              </Title>
                            </div>
                          </Row>
                        </Space>
                      </Col>
                    </Row>
                    {/* end move to component */}
                  </div>
                  <div style={{ alignItems: "center" }}>
                    <img src={screens["lg"] ? tagLg : tag} alt="TAG" style={{ height: '100%', width: '100%' }} />
                  </div>
                  {
                    screens["lg"] ? '' :
                      <div style={{ alignItems: "center" }}>
                        <img src={segMb} alt="TAG" style={{ height: '100%', width: '100%' }} />
                      </div>
                  }
                </Space>
                <Row style={{ justifyContent: "end" }}>
                  <Col md={12} xs={0}>
                    <NextBackBtnComponent
                      id='simTrf-step3-payandsign'
                      value="/opciones/contrato-firma-pago/"
                      rowClassName="rowClassName"
                    ></NextBackBtnComponent>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Layout>
        </Space>
      </Layout>
      <Affix offsetBottom={1}>
        {/* <NextBackBtnComponent id="fix-mobile-footer" className="mobileStyle"></NextBackBtnComponent> */}
        <div
          id="fix-mobile-footer"
          className="mobileStyle"
        // style={{
        //   backgroundColor: "#ffff",
        //   boxShadow: "4px 0px 10px rgba(143, 171, 195, 0.3)",
        // }}
        >
          <Row justify="center" align="middle" style={{ padding: "1rem" }}>
            <Col style={{ width: "50%" }}>
              <BackBtn label={"Volver"} title="Volver atrás"></BackBtn>
            </Col>
            <Col style={{ width: "50%" }}>
              <NextStepBtnComponent
                id='simTrf-step3-payandsign'
                value={'/opciones/contrato-firma-pago/'}
                text={"Siguiente"}
                action={() => {
                  alert("Clicked");
                }}
              />
            </Col>
          </Row>
        </div>
      </Affix>
      <div id="footer">
        <MinimalFooterComponent />
      </div>
    </div>
  );
}

export default ContractTAGServiceContainer;
